module.exports = __webpack_public_path__ + "static/c2-27189702da50d72d19f0362df510d78e.png";